import React from "react";

const recordings = {
  id: "recordings-group",
  // title: 'Media',
  type: "group",
  children: [
    {
      id: "recordings",
      title: "Recordings",
      type: "item",
      url: "/recordings",
      icon: React.createElement(
        "svg",
        {
          width: 20,
          height: 20,
          viewBox: "0 0 24 24",
          fill: "none",
          stroke: "currentColor",
          strokeWidth: 2,
          strokeLinecap: "round",
          strokeLinejoin: "round",
        },
        React.createElement("path", {
          d: "M9 19V6l12-3v13M9 19c0 1.105-1.343 2-3 2s-3-.895-3-2 1.343-2 3-2 3 .895 3 2zm12-3c0 1.105-1.343 2-3 2s-3-.895-3-2 1.343-2 3-2 3 .895 3 2zM9 10l12-3",
        }),
      ),
    },
  ],
};

export default recordings;
